import ExecutionEnvironment from './ExecutionEnvironment';
import { ENVIRONMENT } from './ExecutionEnvironmentName';

/**
 * Maps browser host names to {@link ExecutionEnvironment}.
 */
export default class ExecutionEnvironmentResolver {
  /**
   * @param {string} hostname
   * @returns {import('./ExecutionEnvironmentName').ExecutionEnvironmentName}
   */
  static resolveName(hostname) {
    if (/^localhost$/i.test(hostname) || /^127\.0\.0\.1$/.test(hostname)) {
      return ENVIRONMENT.DEVELOPMENT;
    }

    if (/^stg\.sstock\.milbon\.co\.jp$/i.test(hostname)) {
      return ENVIRONMENT.STAGING;
    }

    return ENVIRONMENT.PRODUCTION;
  }

  /**
   * @param {string} hostname
   * @returns {ExecutionEnvironment}
   */
  static fromHostname(hostname) {
    return new ExecutionEnvironment(ExecutionEnvironmentResolver.resolveName(hostname), {
      hostname,
    });
  }

  /**
   * @returns {ExecutionEnvironment}
   */
  static resolve() {
    const hostname = typeof location !== 'undefined' ? location.hostname : '';
    return ExecutionEnvironmentResolver.fromHostname(hostname);
  }
}
